<template>
  <v-card>
    <!-- booking statistics -->
    <v-card-text class="text-xs-center px-0">
      <v-layout v-if="screener" row wrap class="grey lighten-4 pa-3">
        <!-- Total -->
        <v-flex xs2>
          <div>
            <div class="greyDarken3--text display-2">{{total_bookings}}</div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.save.booking.statistics.total.bookings") }}
            </div>
          </div>
        </v-flex>
        <!-- Attendees -->
        <v-divider vertical></v-divider>
        <v-flex  xs2>
          <div>
            <div class="greyDarken3--text display-2">{{total_booking_attendees}}</div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.save.booking.statistics.total.attendees") }}
            </div>
          </div>
        </v-flex>
        <!-- Cancelled Bookings -->
        <v-divider vertical></v-divider>
        <v-flex  xs2>
          <div>
            <div class="greyDarken3--text display-2">{{total_cancel_bookings}}</div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.save.booking.statistics.total.cancelled") }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-layout row wrap justify-end>
        <v-flex md5 >
          <v-select
              outline
              class="pl-2"
              v-model="booking_type"
              :items="booking_filters"
              item-text="text"
              item-value="value"
              @change="getDataFromApi"
              :label="$t('screener.bookings.list.filter_bookings')"
            ></v-select>
        </v-flex>
      </v-layout>
    </v-card-actions>
    <v-layout row wrap>
      <v-flex>
        <v-data-table
          :headers="table_headers"
          :items="bookings.data"
          v-bind:pagination.sync="pagination"
          :total-items="bookings.total"
          :rowsPerPageItems="[pagination.perPage]"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{props.item.id}}</td>
              <td class="text-xs-left">{{props.item.consumer_email}}</td>
              <td class="text-xs-left ">{{DEFINES.BOOKING_STATUS_STR[props.item.status]}}</td>
              <td class="text-xs-left">{{props.item.seat_indexes.length}}</td>
              <td class="text-xs-left">
                <span v-if="props.item.attended_seat_indexes">{{props.item.attended_seat_indexes.length}}</span>
                <span v-else>NA</span>
              </td>
              <td class="text-xs-left">
                <span v-if="props.item.cancelled_at">{{fmtTime(props.item.cancelled_at)}}</span>
                <span v-else-if="props.item.booked_at">{{fmtTime(props.item.booked_at)}}</span>
                <span v-else-if="props.item.locked_at">{{fmtTime(props.item.locked_at)}}</span>
              </td>
              <td class="text-xs-left">
                <TicketsDialog :disabled="props.item.status!=DEFINES.BOOKING_STATUS_INT['BOOKED']" :consumer_email="props.item.consumer_email" :screener="screener" :booking="props.item" @onCancelled="getDataFromApi"></TicketsDialog>
              </td>
            </tr>
          </template>
          <template v-if="this.search" v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ $t("rms.alert.search_not_found",{
                'search':this.search
              }) }}
            </v-alert>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import {seatMethods,seatCategoryMethods} from "@/mixins/seats"
import TicketsDialog from "@/components/screener/physicalEvent/ticket/TicketsDialog"
import i18n from "@/i18n";
import { mapGetters} from 'vuex';
import {utcToTz} from '@/helper';
import DEFINES from "@/defines"
export default {
  name: "Bookings",
  props: {
    screener: {
      type: Object,
      default: null,
    },
    total_attendees:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pagination: {
        sortBy: "created_at",
        descending: true,
        perPage: 20,
        page: 1,
      },
      bookings: {
        data:[],
      },
      total_bookings:null,
      total_booking_attendees:null,
      total_cancel_bookings:null,
      search: '',
      loader:false,
      seats:null,
      booking_type:DEFINES.BOOKING_STATUS_INT['ALL'],
      booking_filters: [
        {
          text: "All",
          value: DEFINES.BOOKING_STATUS_INT['ALL']
        },
        {
          text: i18n.t('screener.physical.booking.type.locked'),
          value: DEFINES.BOOKING_STATUS_INT['LOCKED']
        },
        {
          text: i18n.t('screener.physical.booking.type.booked'),
          value: DEFINES.BOOKING_STATUS_INT['BOOKED']
        },
        {
          text: i18n.t('screener.physical.booking.type.cancelled'),
          value: DEFINES.BOOKING_STATUS_INT['CANCELLED']
        }
      ]
    }
  },
  components: {
    TicketsDialog
  },
  mixins:[seatMethods],
  created() {
    this.getDataFromApi();
  },
  computed: {
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
    }),
    table_headers(){
      return [
        {
          text: i18n.t('screener.physical.bookings.table.title.id'),
          align: "left",
          sortable: false,
          value:'id'
        },
        {
          text: i18n.t('screener.physical.bookings.table.title.consumer.email'),
          sortable: false,
          align: "left",
          value: "consumer_email",
        },
        {
          text: i18n.t('screener.physical.bookings.table.title.status'),
          align: "left",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t('screener.physical.bookings.table.title.total_seats'),
          align: "left",
          sortable: false,
          value: "seat_indexes",
        },
        {
          text: i18n.t('screener.physical.bookings.table.title.attended_seats'),
          align: "left",
          sortable: false,
          value: "attended_seat_indexes",
        },
        {
          text: this.bookingsTimeText(),
          align: "left",
          sortable: false,
          value: "booked_at",
        },
        {
          text: "Action",
          align: "left",
          value: "delete",
          sortable: false,
        },
      ]}

  },
  watch: {
    pagination: {
      handler() {
        if (this.$route.params.screener_id) this.getDataFromApi();
      },
      deep: true,
    },
    search() {
      if (this.search.length > 2 && this.$route.params.screener_id) {
        this.getDataFromApi();
      }
      if (!this.search.length && this.$route.params.screener_id) {
        this.getDataFromApi();
      }
    },
    screener: {
      deep: true,
      handler: function () {
        if (this.screener && this.screener.event_type != DEFINES.SCREENER_TYPE.VIRTUAL) {
          this.setSeats();
        }
      },
    },
    total_booking_attendees: {
      deep: true,
      handler: function () {
        this.$emit("update:total_attendees", this.total_booking_attendees);
        }
    },
  },
  methods: {
    async getDataFromApi() {
       this.loader = true
      try{
        let response = await this.$store.dispatch('booking/listEventBookings',{
          screener_id: this.$route.params.screener_id,
          status: this.booking_type,
          page: this.pagination.page,
          perPage: this.pagination.perPage
        })
        this.bookings = response.bookings;
        this.total_bookings = response.total_bookings;
        this.total_booking_attendees = response.total_booking_attendees;
        this.total_cancel_bookings = response.total_cancel_bookings;
      }catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
      this.loader = false;
    },

    setSeats() {
      this.seats = this.screener.physical_venue.seats;
    },

    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, 'MMMM Do YYYY, h:mm a');
    },

    bookingsTimeText(){
      // Return table header booking time as per te booking type
      switch(this.booking_type){
        case DEFINES.BOOKING_STATUS_INT['BOOKED']:
          return  i18n.t('screener.physical.bookings.table.title.booked_at');

        case DEFINES.BOOKING_STATUS_INT['LOCKED']:
          return  i18n.t('screener.physical.bookings.table.title.locked_at');

        case DEFINES.BOOKING_STATUS_INT['CANCELLED']:
          return  i18n.t('screener.physical.bookings.table.title.cancelled_at');
      }
    }
  }
};
</script>

